import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../slices/apps/customerSlice";

// sayfalar, modallar vs.
import CustomerTable from "./CustomerTable";

const Customers = () => {
  document.title = "Müşteriler | Metiner Avantaj+";

  const dispatch = useDispatch();

  // states
  const [loading, setLoading] = useState(true);

  const { customersRefresh } = useSelector((state) => {
    return {
      customersRefresh: state.customer.customersRefresh,
    };
  }, shallowEqual);

  const fetchData = async () => {
    setLoading(true);

    try {
      await dispatch(fetchCustomers());
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, customersRefresh]);

  if (loading) {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "50vh" }}
            >
              <Spinner color="primary">Yükleniyor...</Spinner>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <CustomerTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Customers;
